import React from 'react';
import { scanMentionSpans } from '@/utils/atMention';

/**
 * Purple highlight for committed @-mentions only; plain text after the terminating space stays default.
 */
export function renderWithMentions(text: string): React.ReactNode {
  const spans = scanMentionSpans(text);
  if (spans.length === 0) return text;

  const parts: React.ReactNode[] = [];
  let lastIndex = 0;

  for (const span of spans) {
    if (span.start > lastIndex) {
      parts.push(
        <React.Fragment key={`t-${lastIndex}`}>{text.slice(lastIndex, span.start)}</React.Fragment>
      );
    }
    parts.push(
      <span key={`at-${span.start}`} className="at-token">
        {text.slice(span.start, span.end)}
      </span>
    );
    lastIndex = span.end;
  }

  if (lastIndex < text.length) {
    parts.push(<React.Fragment key={`t-${lastIndex}`}>{text.slice(lastIndex)}</React.Fragment>);
  }

  return parts;
}
